import React from "react";

const Close = ({ onclick }) => {
  return (
    <div
      className=" text-2xl flex flex-row-reverse items-center gap-1 mb-4 sticky mt-4 bg-[#F5F7F9] cursor-pointer hover:text-[var(--MColor)] stroke-black hover:stroke-[var(--MColor)] transition-all"
      onClick={onclick}
    >
      <svg
        className=" stroke-none"
        xmlns="http://www.w3.org/2000/svg"
        width="23.832"
        height="23.832"
        viewBox="0 0 23.832 23.832"
      >
        <path
          id="ic_cancel_24px"
          d="M13.916,2A11.916,11.916,0,1,0,25.832,13.916,11.905,11.905,0,0,0,13.916,2Zm5.958,16.194-1.68,1.68L13.916,15.6,9.638,19.874l-1.68-1.68,4.278-4.278L7.958,9.638l1.68-1.68,4.278,4.278,4.278-4.278,1.68,1.68L15.6,13.916Z"
          transform="translate(-2 -2)"
          fill="rgba(206,8,8,0.84)"
        />
      </svg>
    </div>
  );
};

export default Close;
